import { gql } from '@apollo/client'

// Query to get a list of wallets based on filters
export const WALLETS_QUERY = gql`
  query Wallets($filters: WalletFilters!) {
    wallets(filters: $filters) {
      walletID
      entity {
        entityType
        entityID
        entityCode
        entityName
      }
      walletType
      isBilateral
      currency
      walletBalance
      remainingCreditBalance
      active
    }
  }
`
